import { createContext, useContext } from 'react';
export const DropdownContext = createContext(null);
export function useDropdownContext() {
    const dropdownContextInstance = useContext(DropdownContext);
    if (dropdownContextInstance === null) {
        throw new Error('Tried to use DropdownContext when none exists.');
    }
    return dropdownContextInstance;
}
//# sourceMappingURL=DropdownContext.js.map